import { connect } from 'react-redux';
import { type StoreState } from '../../../types/StoreState';
import {
  selectOnCancel,
  selectOnClick,
  selectOnPaymentAuthorized,
  selectOnPaymentAuthorizedInit,
  selectOnShippingContactSelected,
  selectSessionId,
  selectTopProps,
  selectWidgetRootWrapperDh,
} from '../../../selectors';
import { createPayPalOrder } from '../../../actions/payment/createPayPalOrder';
import { updatePayPalOrder } from '../../../actions/payment/updatePayPalOrder';
import { getPayPalContactPaymentDetails } from '../../../actions/payment/getPayPalContactPaymentDetails';
import { createPayPalPaymentDetails } from '../../../actions/payment/createPayPalPaymentDetails';
import { selectPayPalPaymentData } from '../../../selectors/payment';
import { PayPalController } from './controller';

const connectToProps = connect(
  (state: StoreState) => ({
    sessionId: selectSessionId(state),
    topProps: selectTopProps(state),
    widgetRootWrapperDh: selectWidgetRootWrapperDh(state),
    paymentData: selectPayPalPaymentData(state),
    onClick: selectOnClick(state),
    onShippingContactSelected: selectOnShippingContactSelected(state),
    onPaymentAuthorized: selectOnPaymentAuthorized(state),
    onPaymentAuthorizedInit: selectOnPaymentAuthorizedInit(state),
    onCancel: selectOnCancel(state),
  }),
  {
    createOrder: createPayPalOrder,
    updateOrder: updatePayPalOrder,
    createPaymentDetails: createPayPalPaymentDetails,
    getContactPaymentDetails: getPayPalContactPaymentDetails,
  },
);

export const PayPalControllerConnect = connectToProps(PayPalController);
